import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=270ae48a&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=270ae48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ae48a",
  null
  
)

export default component.exports